export const TV = {
  bg: {
    primary: '#0d0e11',
    secondary: '#131722',
    tertiary: '#1a1e2e',
    hover: '#262d3d',
  },
  text: {
    primary: '#f0f3fa',
    secondary: '#a0a5b8',
    tertiary: '#787d8c',
  },
  accent: {
    primary: '#2962ff',
    secondary: '#ab63fa',
    success: '#26a69a',
    warning: '#ffd700',
    danger: '#e91e63',
  },
  border: {
    primary: '#262d3d',
    secondary: '#1a1e2e',
  },
};

export const SYMBOLS = ['NQ', 'QQQ', 'GC', 'CL', 'ZN'];
export const TIMEFRAMES = ['1s', '5s', '15s', '30s', '45s', '1m', '2m', '3m', '5m', '15m', '30m', '45m', '1h', '2h', '4h', '1D', '1W', '1M'];

export const SIGNALS = [
    "COBRA_LONG", "COBRA_SHORT", "LUX_LONG", "LUX_SHORT",
    "LUX_LONG_12", "LUX_SHORT_12",
    "LUX_LONG_21", "LUX_SHORT_21",
    "SMART_BAND_12", "SMART_BAND_12_SHORT",
    "SMART_BAND_12_CLOSE", "SMART_TRAIL_2", "SMART_TRAIL_2_SHORT", "SMART_TRAIL_3", "SMART_TRAIL_3_SHORT",
    "ALGO_PRO_LONG", "ALGO_PRO_SHORT",
    "COBRA_LONG_DEFAULT", "COBRA_SHORT_DEFAULT",
    "EMA75_CROSS_ABOVE", "EMA75_CROSS_BELOW",
    "EMA200_CROSS_ABOVE_45S", "EMA200_CROSS_BELOW_45S",
    "VGB_LONG", "VGB_SHORT",
    "VGB_LONG_2", "VGB_SHORT_2",
    "VGB_LONG_26", "VGB_SHORT_26",
    "VGB_LONG_2_26", "VGB_SHORT_2_26",
    "VGB_LONG_30", "VGB_SHORT_30",
    "VGB_LONG_2_30", "VGB_SHORT_2_30",
    "VGB_LONG_35", "VGB_SHORT_35",
    "VGB_LONG_2_35", "VGB_SHORT_2_35",
    "VGB_LONG_55", "VGB_SHORT_55",
    "VGB_LONG_2_55", "VGB_SHORT_2_55",
    "COBRA_LONG_15", "COBRA_SHORT_15",
    "COBRA_LONG_13_SLOW", "COBRA_SHORT_13_SLOW",
    "SMART_BAND_17", "SMART_BAND_17_SHORT",
    "COBRA_LONG_18_SLOW", "COBRA_SHORT_18_SLOW",
    "COBRA_LONG_10_SLOW", "COBRA_SHORT_10_SLOW",
    "ALGO_ALPHA_DEFAULT_LONG", "ALGO_ALPHA_DEFAULT_SHORT",
    "ALGO_ALPHA_3_LONG", "ALGO_ALPHA_3_SHORT",
]

export const EXIT_SIGNALS = SIGNALS;

export const CONDITION_TYPES = [
  { value: 'time_bound', label: 'Time Bound (Early → Confirmation)' },
  { value: 'time_window', label: 'Time Window (Bidirectional)' },
  { value: 'sequence_with_exclusion', label: 'Sequence with Exclusion' },
  { value: 'sequence_exclusion_with_equality', label: 'Sequence with Exclusion (At Entry)' },
  { value: 'simultaneous_signals', label: 'Simultaneous Signals' },
  { value: 'is_bullish_when_signal_arrived', label: '📈 Bullish Signal Detection' },
  { value: 'is_bearish_when_signal_arrived', label: '📉 Bearish Signal Detection' },
];

export const inputSx = {
  '& .MuiInputBase-root': {
    bgcolor: TV.bg.secondary,
    borderRadius: '4px',
    fontSize: '13px',
    color: TV.text.primary,
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': { borderColor: TV.border.primary },
    '&:hover fieldset': { borderColor: TV.accent.primary },
    '&.Mui-focused fieldset': { borderColor: TV.accent.primary },
  },
  '& .MuiInputLabel-root': { color: TV.text.secondary, fontSize: '12px' },
  '& .MuiInputLabel-root.Mui-focused': { color: TV.accent.primary },
};

export const selectSx = {
  bgcolor: TV.bg.secondary,
  borderRadius: '4px',
  fontSize: '13px',
  color: TV.text.primary,
  '& .MuiOutlinedInput-notchedOutline': { borderColor: TV.border.primary },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: TV.accent.primary },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: TV.accent.primary },
};

export const cardSx = {
  bgcolor: TV.bg.tertiary,
  border: `1px solid ${TV.border.primary}`,
  borderRadius: '4px',
  mb: 1.5,
  transition: 'all 0.2s ease',
  '&:hover': { borderColor: TV.accent.primary, bgcolor: TV.bg.hover },
};
